export default __webpack_public_path__ + "static/media/eight.4e7b817f.png";